'use client';

import { useState } from 'react';
import { useI18n } from 'next-localization';

import { LinkButton } from '@/components/link-button';
import { NeuIcon } from '@hcahealthcaredpx/neutron-react';

export const EmailTermsAndConditions = (): JSX.Element => {
  const [show, setShow] = useState(false);

  const { t } = useI18n();

  return (
    <div>
      <LinkButton
        onClick={() => setShow((p) => !p)}
        className="my-2 mt-md-0 fs-14"
        aria-expanded={show}
        type="button"
      >
        {t('OAS.Booking.EmailTermsAndConditions')}
        <NeuIcon name={show ? 'keyboard_arrow_up' : 'keyboard_arrow_down'} size="2x" />
      </LinkButton>
      {show && (
        <p className="fs-14 mb-2 text-color-asphalt">
          {t('OAS.Booking.EmailTermsAndConditionsContent')}
        </p>
      )}
    </div>
  );
};
